import { message } from '@utils/wuji-message';

export const isQuotaExceedError = (error) => {
  if (error.name === 'QuotaExceededError') {
    return true;
  }
};

export const promptMessage = (type, msg) => {
  message[type](msg);
};
